import React from 'react'
import Job from './Job';
import Filter from './Filter';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJobsAsync, selectJobs } from '../features/jobs/jobSlice';

export default function JobLists() {

    const { jobs } = useSelector(selectJobs);
    const { sort, search } = useSelector((state) => state.jobs);
    // console.log(jobs);
    const dispatch = useDispatch();
    useEffect(() => {
        // console.log("useeffect is called")
        console.log("calling the fetch job with sort =>", sort)
        dispatch(fetchJobsAsync({ sort, search }));

    }, [dispatch, sort, search]);
    let content = null;
    if (jobs?.length > 0) {
        content = jobs?.map((el) => {
            return <Job key={el.id} job={el} />
        });
    }

    return (
        <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
            <Filter />

            <div className="jobs-list">
                {content}
            </div>
        </main>
    )
}
